import React from "react";
import PropTypes from "prop-types";
import { WORKFLOW_QUERY } from "../queries";
import { RESTART_WORKFLOW, TERMINATE_WORKFLOW, RETRY_WORKFLOW, RESUME_WORKFLOW, PAUSE_WORKFLOW } from "../mutations";
import WorkflowInfo from "./WorkflowInfo";
import { useMutation } from "features/common/security/hooks";
import { useSimpleError, useQueryWithSimpleErrorHandling } from "hooks";

const WorkflowContainer = ({ documentId }) => {
  const showError = useSimpleError();

  const rights = {
    hasRightToEditWorkflow: true,
    hasRightToViewWorkflow: true
  };

  const { data, loading, refetch } = useQueryWithSimpleErrorHandling(WORKFLOW_QUERY, {
    variables: {
      documentId: documentId
    },
    pollInterval: 5000,
    fetchPolicy: "network-only"
  });

  const [terminate] = useMutation(TERMINATE_WORKFLOW, {
    onError: error => showError(error),
    onCompleted: _data => {
      refetch();
    }
  });

  const [retry] = useMutation(RETRY_WORKFLOW, {
    onError: error => showError(error),
    onCompleted: _data => {
      refetch();
    }
  });

  const [restart] = useMutation(RESTART_WORKFLOW, {
    onError: error => showError(error),
    onCompleted: _data => {
      refetch();
    }
  });
  const [resume] = useMutation(RESUME_WORKFLOW, {
    onError: error => showError(error),
    onCompleted: _data => {
      refetch();
    }
  });
  const [pause] = useMutation(PAUSE_WORKFLOW, {
    onError: error => showError(error),
    onCompleted: _data => {
      refetch();
    }
  });

  const actions = {
    terminateWorkflow: workflowId =>
      terminate({
        variables: {
          workflowId: workflowId,
          reason: ""
        }
      }),
    retryWorkflow: workflowId =>
      retry({
        variables: {
          workflowId: workflowId,
          resumeSubworkflowTasks: false
        }
      }),
    restartWorkflow: workflowId =>
      restart({
        variables: {
          workflowId: workflowId,
          useLatestDefinitions: false
        }
      }),
    restartWorkflowWithLatestDefinition: workflowId =>
      restart({
        variables: {
          workflowId: workflowId,
          useLatestDefinitions: true
        }
      }),
    resumeWorkflow: workflowId =>
      resume({
        variables: {
          workflowId: workflowId
        }
      }),
    pauseWorkflow: workflowId =>
      pause({
        variables: {
          workflowId: workflowId
        }
      })
  };

  return (
    <React.Fragment>
      {!loading && data?.documentWorkflows && (
        <WorkflowInfo
          workflows={data?.documentWorkflows || []}
          actions={actions}
          hasRightToEditWorkflow={rights.hasRightToEditWorkflow}
          hasRightToViewWorkflow={rights.hasRightToViewWorkflow}
        ></WorkflowInfo>
      )}
    </React.Fragment>
  );
};

WorkflowContainer.propTypes = {
  documentId: PropTypes.number
};

export default WorkflowContainer;
